import React from 'react';
import { Space, Tooltip } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Button from '../../../../../../../components/common/Button';

interface Props {
  /** true = tümünü işaretle, false = tümünü kaldır; alan kümeleri panelde kalır */
  onSetAll: (value: boolean) => void;
  /** Tooltip metnindeki tip adı (ör. "PT", "MT"); boşsa genel metin */
  typeLabel?: string;
}

/** Panellerdeki "tümünü işaretle/kaldır" ikon buton çifti (BC/VC/PT/MT).
 *  UT'nin düz metinli butonları bilinçli olarak ayrı bırakıldı (farklı sunum). */
export default function CheckAllButtons({ onSetAll, typeLabel }: Props) {
  const label = typeLabel ? `${typeLabel} ` : '';
  return (
    <Space size={4}>
      <Tooltip title={`Set all ${label}checkboxes TRUE`}>
        <Button
          size="small"
          type="primary"
          icon={<CheckOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            onSetAll(true);
          }}
        />
      </Tooltip>
      <Tooltip title={`Set all ${label}checkboxes FALSE`}>
        <Button
          size="small"
          type="default"
          icon={<CloseOutlined />}
          onClick={(e) => {
            e.stopPropagation();
            onSetAll(false);
          }}
        />
      </Tooltip>
    </Space>
  );
}
